import React, { useEffect } from 'react';
// import '../cs/temp.css';
import '../cs/te.css';
import AOS from 'aos';
import "aos/dist/aos.css";

function BlockchainDevelopment() {
  useEffect(() => {
    AOS.init({ duration: 1000, delay: true })
  }, [])
  return (
    <div className="webdev-page" style={{ overflowX: "hidden" }}>
      {/* Banner */}
      <section className="inner-banner-wrap">
        <div
          className="inner-baner-container"
          style={{ backgroundImage: "url(assets/images/banner-pattern1.png)" }}
        >
          <div className="container" data-aos="fade-up">
            <div className="inner-banner-content">
              <h1 className="inner-title">Blockchain Development</h1>
            </div>
          </div>
        </div>
      </section>

      {/* Introduction Section */}
      <section className="intro-section blockchain-intro">
        <div className="container">
          <div className="intro-content">
            <div className="section-header text-left">
              <h2 data-aos="fade-up">Decentralized Solutions for Modern Business</h2>
              <p className="intro-text">
                At Codenix Infotech, we deliver innovative blockchain solutions designed to drive efficiency, transparency, and security. Whether you’re building a brand-new decentralized application or integrating blockchain into existing systems, our expert team tailors solutions to meet your unique business goals and future-proof your operations.
              </p>

              <div className="blockchain-badges text-center d-none">
                <div className="badge">
                  <i className="fab fa-ethereum"></i>
                  <span>Ethereum</span>
                </div>
                <div className="badge">
                  <i className="fab fa-bitcoin"></i>
                  <span>Bitcoin</span>
                </div>
                <div className="badge">
                  <i className="fas fa-link"></i>
                  <span>Hyperledger</span>
                </div>
                <div className="badge">
                  <i className="fas fa-code-branch"></i>
                  <span>Solana</span>
                </div>
              </div>
            </div>

          </div>
          <div className="intro-image blockchain-graphic">
            {/* <div className="blockchain-animation">
              <div className="block block-1"></div>
              <div className="block block-2"></div>
              <div className="block block-3"></div>
              <div className="block block-4"></div>
              <div className="chain chain-1"></div>
              <div className="chain chain-2"></div>
              <div className="chain chain-3"></div>
            </div> */}
          </div>
        </div>
      </section>

      {/* Our Services Section */}
      <section className="webdev-services-section blockchain-services">
        <div className="container">
          <div className="section-header">
            <h2>Our Blockchain Solutions</h2>
            <p className="section-description">
              Comprehensive blockchain development services to transform your business operations
            </p>
          </div>

          <div className="services-grid" data-aos="fade-up-left" data-aos-delay="200">
            <div className="service-card">
              <div className="service-icon">
                <i className="fas fa-file-contract"></i>
              </div>
              <h3>Smart Contracts</h3>
              <p>Secure, automated contracts that streamline transactions, reduce manual intervention, and ensure trust.
              </p>
            </div>

            <div className="service-card">
              <div className="service-icon">
                <i className="fas fa-cube"></i>
              </div>
              <h3>Decentralized Applications</h3>
              <p>Scalable blockchain-powered apps offering enhanced security, reliability, and advanced functionality.
              </p>
            </div>

            <div className="service-card">
              <div className="service-icon">
                <i className="fas fa-project-diagram"></i>
              </div>
              <h3>Custom Blockchain Solutions</h3>
              <p>End-to-end blockchain architectures designed specifically for your industry and business challenges.
              </p>
            </div>

            <div className="service-card">
              <div className="service-icon">
                <i className="fas fa-coins"></i>
              </div>
              <h3>Tokenization</h3>
              <p>Custom tokens and cryptocurrencies built with regulatory compliance, optimized tokenomics, and seamless distribution.
              </p>
            </div>

            <div className="service-card">
              <div className="service-icon">
                <i className="fas fa-handshake"></i>
              </div>
              <h3>Blockchain Consultation</h3>
              <p>Strategic advice to identify blockchain opportunities, optimize workflows, and maximize ROI.
              </p>
            </div>

            <div className="service-card">
              <div className="service-icon">
                <i className="fas fa-exchange-alt"></i>
              </div>
              <h3>Integration Services</h3>
              <p>Seamless integration of blockchain into your systems to enhance efficiency, security, and automation.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Development Process Section */}
      <section className="design-process-section blockchain-process">
        <div className="container">
          <div className="section-header">
            <h2>Our Blockchain Development Process</h2>
            <p className="section-description">
              A strategic approach to delivering secure and scalable blockchain solutions tailored to your business
            </p>
          </div>

          <div className="process-timeline">
            {[
              {
                num: 1,
                title: "Requirement Analysis",
                text: "Understand your goals, workflows, and integration needs to define a clear blockchain strategy"
              },
              {
                num: 2,
                title: "Solution Design",
                text: "Design blockchain architecture that aligns with your business objectives and scalability requirements."
              },
              {
                num: 3,
                title: "Development",
                text: "Build robust, future-ready blockchain solutions using cutting-edge frameworks and technologies."
              },
              {
                num: 4,
                title: "Testing & Validation",
                text: "Conduct rigorous performance and security testing to ensure reliability"
              },
              {
                num: 5,
                title: "Deployment",
                text: "Implement and integrate your blockchain solution seamlessly into your environment"
              },
              {
                num: 6,
                title: "Support & Maintenance",
                text: "Provide ongoing monitoring, upgrades, and optimization to ensure lasting performance"
              }
            ].map((step) => (
              <div className="process-step" key={step.num} data-aos="fade-left" data-aos-delay="200">
                <div className="step-number">{step.num}</div>
                <div className="step-content">
                  <h3>{step.title}</h3>
                  <p>{step.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Use Cases Section */}
      <section className="blockchain-use-cases d-none">
        <div className="container">
          <div className="section-header">
            <h2>Blockchain Applications Across Industries</h2>
            <p className="section-description">
              Discover how our blockchain solutions are transforming various sectors
            </p>
          </div>

          <div className="use-cases-grid" >
            <div className="use-case-card">
              <div className="use-case-icon">
                <i className="fas fa-chart-line"></i>
              </div>
              <h3>Finance</h3>
              <p>Secure payment systems, cross-border transactions, and automated compliance</p>
            </div>

            <div className="use-case-card">
              <div className="use-case-icon">
                <i className="fas fa-truck"></i>
              </div>
              <h3>Supply Chain</h3>
              <p>Product traceability, counterfeit prevention, and process optimization</p>
            </div>

            <div className="use-case-card">
              <div className="use-case-icon">
                <i className="fas fa-heartbeat"></i>
              </div>
              <h3>Healthcare</h3>
              <p>Secure patient data sharing, medication traceability, and clinical trials</p>
            </div>

            <div className="use-case-card">
              <div className="use-case-icon">
                <i className="fas fa-gavel"></i>
              </div>
              <h3>Legal</h3>
              <p>Smart contracts, intellectual property protection, and compliance automation</p>
            </div>

            <div className="use-case-card">
              <div className="use-case-icon">
                <i className="fas fa-home"></i>
              </div>
              <h3>Real Estate</h3>
              <p>Property ownership records, transparent transactions, and tokenized assets</p>
            </div>

            <div className="use-case-card">
              <div className="use-case-icon">
                <i className="fas fa-vote-yea"></i>
              </div>
              <h3>Governance</h3>
              <p>Secure voting systems, transparent decision-making, and public records</p>
            </div>
          </div>
        </div>
      </section>

      {/* Key Features Section */}
      <section className="design-principles-section blockchain-features">
        <div className="container">
          <div className="section-header">
            <h2>Key Features of Our Blockchain Solutions</h2>
            <p className="section-description">
              What makes our blockchain development services stand out
            </p>
          </div>

          <div className="services-grid">
            {[
              {
                icon: "fas fa-shield-alt",
                title: "Enhanced Security",
                text: "Tamper-proof systems to safeguard sensitive data and transactions."
              },
              {
                icon: "fas fa-eye",
                title: "Transparency",
                text: "Build trust with auditable, transparent systems"
              },
              {
                icon: "fas fa-cogs",
                title: "Custom Solutions",
                text: "Solutions tailored to your industry and specific requirements"
              },
              {
                icon: "fas fa-expand-arrows-alt",
                title: "Scalability",
                text: "Scale effortlessly as your business and transaction volumes grow."
              },
              {
                icon: "fas fa-microchip",
                title: "Latest Technology",
                text: "Built with the latest blockchain tools, platforms, and frameworks."
              },
              {
                icon: "fas fa-headset",
                title: "Ongoing Support",
                text: "Ongoing updates and monitoring to keep your systems ahead of the curve"
              }
            ].map((feature, idx) => (
              <div className="service-card" key={idx} data-aos="fade-up-left" data-aos-delay="200">
                <div className="service-icon">
                  <i className={feature.icon}></i>
                </div>
                <h3>{feature.title}</h3>
                <p>{feature.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>



      {/* CTA Section */}
      <section className="cta-section mt-5 blockchain-cta">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Transform Your Business with Blockchain?</h2>
            <p>Let's create a secure, transparent, and efficient blockchain solution tailored to your needs.</p>
            <a href="/contact" className="cta-button">Schedule a Blockchain Consultation</a>
          </div>
        </div>
      </section>
    </div>
  );
}

export default BlockchainDevelopment;
